import { render } from "./PlayerChat.vue?vue&type=template&id=2000ea87&scoped=true&ts=true"
import script from "./PlayerChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlayerChat.vue?vue&type=script&setup=true&lang=ts"

import "./PlayerChat.vue?vue&type=style&index=0&id=2000ea87&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2000ea87"],['__file',"src/components/player/PlayerChat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2000ea87"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2000ea87', __exports__)) {
    console.log('reload')
    api.reload('2000ea87', __exports__)
  }
  
  module.hot.accept("./PlayerChat.vue?vue&type=template&id=2000ea87&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('2000ea87', render)
  })

}


export default __exports__